function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.5,1h-17C1.224,1,1,1.224,1,1.5v17C1,18.776,1.224,19,1.5,19h17c0.276,0,0.5-0.224,0.5-0.5v-17 C19,1.224,18.776,1,18.5,1z M18,18H2V2h16V18z M4,8c0-1.654,1.346-3,3-3s3,1.346,3,3c0,1.168-0.697,1.792-1.312,2.342 C8.05,10.912,7.5,11.404,7.5,12.5C7.5,12.776,7.276,13,7,13s-0.5-0.224-0.5-0.5c0-1.543,0.843-2.298,1.521-2.904 C8.646,9.037,9,8.687,9,8c0-1.103-0.897-2-2-2S5,6.897,5,8c0,0.276-0.224,0.5-0.5,0.5S4,8.276,4,8z M7.75,14.25 C7.75,14.664,7.414,15,7,15s-0.75-0.336-0.75-0.75S6.586,13.5,7,13.5S7.75,13.836,7.75,14.25z M12,6.5C12,6.224,12.224,6,12.5,6h3 C15.776,6,16,6.224,16,6.5S15.776,7,15.5,7h-3C12.224,7,12,6.776,12,6.5z M12,10.5c0-0.276,0.224-0.5,0.5-0.5h3 c0.276,0,0.5,0.224,0.5,0.5S15.776,11,15.5,11h-3C12.224,11,12,10.776,12,10.5z M12,14.5c0-0.276,0.224-0.5,0.5-0.5h3 c0.276,0,0.5,0.224,0.5,0.5S15.776,15,15.5,15h-3C12.224,15,12,14.776,12,14.5z"
});

function SvgAssessment2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment2);
export default __webpack_public_path__ + "static/media/assessment_2.967de868.svg";
export { ForwardRef as ReactComponent };